import(/* webpackMode: "eager" */ "/builds/infra/front/marketing/blog-deploy-all/blog-next-vk-cloud-kz/blog-next/src/app/blog/(pages)/error.tsx");
